import React from 'react';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { Common } from '../../utils/common';

const Highcharts = window.Highcharts;

function ConnectedProspectPercentage({ chartData }) {
  const formattedChartData = [
    Number(chartData[0].connected_percentage),
    Number(chartData[0].total),
  ];

  const chartOptions = {
    chart: {
      height: 300,
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: formattedChartData[0] + '%',
      align: 'center',
      verticalAlign: 'middle',
      y: 40,
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>',
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    plotOptions: {
      series: {
        colors: ['#1F6587', '#EDEBEB'],
        cursor: 'pointer',
        point: {
          events: {
            click: function () {
              if (this.series.name === 'Prospects') {
                if (Common.in_crm_mode() || window.IN_SCHEDULED_REPORT_MODE) {
                  return;
                }
                location.href =
                  '//' + location.host + '/filtered_call_details/all/prospects/all/all/all';
              }
            },
          },
        },
        dataLabels: {
          enabled: true,
          distance: -50,
          style: {
            fontWeight: 'bold',
            color: 'white',
          },
        },
        startAngle: -90,
        endAngle: 90,
        center: ['50%', '75%'],
      },
    },
    series: [
      {
        type: 'pie',
        name: 'Prospects',
        innerSize: '60%',
        data: [
          ['', formattedChartData[0]],
          {
            name: 'Other',
            y: formattedChartData[1],
            dataLabels: {
              enabled: false,
            },
          },
        ],
      },
    ],
  };
  return (
    <div className='report_data_container'>
      <div className='title'>Connected Prospects</div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
}

ConnectedProspectPercentage.propTypes = {
  chartData: PropTypes.arrayOf(
    PropTypes.exact({ connected_percentage: PropTypes.number, total: PropTypes.number })
  ).isRequired,
};

export default ConnectedProspectPercentage;
